<template>
  <v-menu>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on"  text>{{$store.state.current.role.name}}<v-icon>mdi-chevron-down</v-icon></v-btn>
    </template>
    <v-list>
        <v-list-item @click="selectRole(per)" v-for="per in $store.getters['current/getRoles']" :key="per.id" link>{{per.name}}</v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  methods:{
    selectRole(role){
      this.$store.commit('current/setRole', role);
      this.$emit('update', role);
    }
  }
}
</script>

<style>

</style>